import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreButtonHoverIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import { SUB_ROLE } from "../../../../utils/constants/profiles";
import {
  useAddServiceMutation,
  useDeleteServiceGroupMutation,
  useGetServiceGroupQuery,
  useGetServicesQuery,
  useRemoveServiceGroupMutation,
  useRemoveServiceMutation,
  useSuggestStudioServicesMutation,
  useUpdateServiceMutation,
} from "../../../api/admin/ServiziApi";
import { useGetStudioIdQuery } from "../../../api/admin/gestisciStudioApi";
import { Divider, IconButton, Tooltip } from "@mui/material";
import DetailServiceBusiness from "./DetailServiceBusiness";
import CoreTextArea from "../../../../app/core/components/CoreTextArea/CoreTextArea";
import CoreIAicon from "../../../../app/core/components/CoreIAicon/CoreIAicon";
import CoreViewLists from "../../../../app/core/components/CoreViewLists/CoreViewLists";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AddService from "../../../admin/ServiziPage/AddService";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import CoreDialog from "../../../../app/core/components/CoreDialog/CoreDialog";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import ServiceTwoLevel from "../../../admin/ServiziPage/ServiceTwoLevel";
import CorePagination from "../../../../app/core/components/CorePagination/CorePagination";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import StarsRoundedIcon from "@mui/icons-material/StarsRounded";

const ServiziStudioPage = () => {
  const [services, setServices] = useState([]);
  const [open, setOpen] = useState(false);
  const [service, setService] = useState();
  const [newOpen, setNewOpen] = useState(false);
  const [group, setGroup] = useState();
  const [openRows, setOpenRows] = useState({});
  const [openAddService, setOpenAddService] = useState(false);
  const [confirmDeleteGroupDialog, setConfirmDeleteGroupDialog] =
    useState(false);
  const [showConfirmRemoveDialog, setShowConfirmRemoveDialog] = useState(false);
  const [openServiceTwoLevelModal, setOpenServiceTwoLevelModal] =
    useState(false);
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [newService, setNewService] = useState({
    Name: "",
    Description: "",
  });

  const appConfig = useSelector((state) => state.app.appConfig);
  const studioId = useSelector((state) => state.app.studioId);
  const adminId = useSelector((state) => state.app.adminId);
  const subRole = useSelector((state) => state.app.subRole);
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const {
    data: generalServices,
    isLoading,
    refetch: refetchServices,
  } = useGetServicesQuery(page);

  const {
    data: studio,
    isLoading: loadingStudio,
    refetch: refetchStudio,
  } = useGetStudioIdQuery(studioId);

  const { data: serviceLevel, refetch: refetchServiceLevel } =
    useGetServiceGroupQuery(studioId, {
      skip: !appConfig?.modules?.services?.serviceTwoLevel,
    });

  const [addService] = useAddServiceMutation();
  const [removeService] = useRemoveServiceMutation();
  const [updateService] = useUpdateServiceMutation();
  const [suggestStudioServices, { isLoading: isLoadingSuggest }] =
    useSuggestStudioServicesMutation();

  const [deleteGroupService] = useDeleteServiceGroupMutation();
  const [removeServiceGroup] = useRemoveServiceGroupMutation();

  useEffect(() => {
    const serviceLevelData =
      appConfig?.modules?.services?.serviceTwoLevel &&
      serviceLevel &&
      serviceLevel?.Data;

    // Controllo parametrizzato del 730 Automatico (serviceWithLLM)
    const filteredItems = appConfig?.modules?.services?.serviceWithLLM
      ? generalServices?.Data?.items
      : generalServices?.Data?.items?.filter((el) => el.aiPrompt === null);

    const filterService = appConfig?.modules?.services?.serviceTwoLevel
      ? filteredItems?.filter((el) => el.practiceServiceCategoryId === null)
      : filteredItems;

    if (filterService) {
      setServices(filterService);
    }

    if (serviceLevelData) {
      setGroup(serviceLevel?.Data);
    }
  }, [generalServices, appConfig, serviceLevel]);

  const handleProponiServiceOpen = () => {
    setNewService({
      Name: "",
      Description: "",
    });
    setNewOpen(true);
  };

  const handleProponiServiceClose = () => setNewOpen(false);

  const handleSuggestService = () => {
    suggestStudioServices(newService)
      .then((res) => {
        if (res.data.Exception) {
          toast.error(res.data.Exception);
        } else if (res.data.Result === 1) {
          toast.success("Servizio proposto con successo");
          handleProponiServiceClose();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleActivationService = (elem) => {
    const serviceData = {
      practiceServiceId: elem.id,
      StudioId: studioId,
      Description: elem.description,
      IsAvailableToUser: studio?.Data?.adminStudioServices?.find(
        (e) => e.practiceServiceId === elem.id
      )
        ? false
        : true,
    };

    (studio?.Data?.adminStudioServices?.find(
      (e) => e.practiceServiceId === elem.id
    )
      ? removeService(serviceData)
      : addService(serviceData)
    )
      .then(() => {
        const successMessage = studio?.Data?.adminStudioServices.some(
          (e) => e.practiceServiceId === elem.id
        )
          ? `Servizio disattivato`
          : `Servizio attivato`;
        toast.success(successMessage);
        refetchStudio();
        refetchServices();
      })
      .catch(() => {
        toast.error(t("ReqErr"));
      });
  };

  const handleActivationMyService = (elem) => {
    const serviceData = {
      practiceServiceId: elem.id,
      StudioId: studioId,
      Description: elem.description,
      IsAvailableToUser: studio?.Data?.adminStudioServices.some(
        (e) => e.practiceServiceId === elem.id && e.isAvailableToUser === true
      )
        ? false
        : true,
    };

    updateService(serviceData)
      .unwrap()
      .then((res) => {
        if (res.Exception) {
          toast.error(res.Exception);
        } else if (res.Result === 1) {
          toast.success(t("ServiceUpdated"));
        }
        refetchServices();
        refetchStudio();
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleEditDescription = (service, description) => {
    const serviceBodyCheck = {
      id: adminId,
      practiceServiceId: service.id,
      studioId: studioId,
      Description: description,
      isAvailableToUser: true,
    };
    updateService(serviceBodyCheck)
      .unwrap()
      .then((res) => {
        if (res.Exception) {
          toast.error(res.Exception);
        } else if (res.Result === 1) {
          toast.success(t("ServiceUpdated"));
          handleClose();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleOpen = (el) => {
    setService(el);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleOpenAddService = (el) => {
    setService(el);
    setOpenAddService(true);
  };

  const handleCloseAddService = () => {
    setOpenAddService(false);
    setService();
  };

  const handleDeleteGroup = (el) => {
    setService(el);
    setConfirmDeleteGroupDialog(true);
  };
  const handleCloseDeleteDialod = () => setConfirmDeleteGroupDialog(false);

  const handleRemoveServiceGroup = (el) => {
    setService(el);
    setShowConfirmRemoveDialog(true);
  };
  const handleCloseRemoveDialod = () => setShowConfirmRemoveDialog(false);

  const handleOpenServiceTwoLevel = (el) => {
    setService(el);
    setOpenServiceTwoLevelModal(true);
  };

  const handleCloseServiceTwoLevel = () => {
    setOpenServiceTwoLevelModal(false);
    setService();
  };

  const handleRefecthDocuments = () => {
    refetchServices();
    refetchStudio();
    if (appConfig?.modules?.services?.serviceTwoLevel) refetchServiceLevel();
  };

  const getServiceButtonProps = (el) => {
    const isServiceActive = studio?.Data?.adminStudioServices.some(
      (e) => e.practiceServiceId === el.id && e.isAvailableToUser === true
    );

    return {
      testo: isServiceActive ? "disattiva" : "attiva",
      className: isServiceActive ? "btn-round-outline" : "btn-round",
    };
  };

  const handleToggleCollapse = (rowId) => {
    setOpenRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Inverti lo stato di apertura solo per questa riga
    }));
  };

  const handleConfermDeleteDialog = async () => {
    deleteGroupService(service.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("NotDeletedGroup"));
        return;
      }
      toast.success(t("DeletedGroup"));
      handleCloseDeleteDialod();
    });
  };

  const handleConfermRemoveDialog = async () => {
    removeServiceGroup(service.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("ServiceNotRemoved"));
        return;
      }
      toast.success(t("ServiceRemoved"));
      handleCloseRemoveDialod();
    });
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <div className="w-full">
      <h2>{t("Services")}</h2>
      <div className="flex pb-4 space-x-4">
        <CoreButtonHoverIcon
          onClick={handleRefecthDocuments}
          className="text-blue-500 m-1 flex flex-row space-x-2 border"
          testo={t("Refresh")}
          icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
        />

        {SUB_ROLE.ADMIN === subRole && (
          <div className="">
            {appConfig?.modules?.services?.creationServiceForAdmin ? (
              <CoreButtonHoverIcon
                className="text-blue-700 m-1"
                icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
                testo={t("Services")}
                onClick={() => handleOpen(null)}
              />
            ) : (
              <div className="">
                <CoreButtonHoverIcon
                  className="text-blue-700 m-1"
                  icon={<AddBoxRoundedIcon className="text-blue-700" />}
                  testo="Proponi servizio"
                  onClick={handleProponiServiceOpen}
                />
              </div>
            )}
          </div>
        )}
      </div>
      <div>
        <Divider />
        {group?.length > 0
          ? group.map((el, idx) => (
              <>
                <div className="flex py-5 items-center space-x-16" key={idx}>
                  <div className="flex w-24 h-24 items-center">
                    <img
                      alt="Immagine"
                      src={el.iconURL || "/img/placeholder-image.svg"}
                      style={{
                        maxWidth: "90px",
                        maxHeight: "90px",
                      }}
                    />
                  </div>
                  <div className="w-6/12">
                    <h3 className="m-0">{el.name}</h3>
                    <p className="m-0">{el.description}</p>
                  </div>
                  <Divider orientation="vertical" flexItem />

                  <div className="flex  items-center">
                    {subRole === "Responsabile" && el.studioId && (
                      <>
                        <Tooltip title={t("Edit")}>
                          <IconButton
                            variant="outlined"
                            onClick={() => handleOpenServiceTwoLevel(el)}
                          >
                            <EditRoundedIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t("Delete")}>
                          <IconButton
                            variant="outlined"
                            onClick={() => handleDeleteGroup(el)}
                          >
                            <DeleteIcon className={"fill-rose-600"} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t("AddService")}>
                          <IconButton
                            variant="outlined"
                            onClick={() => handleOpenAddService(el)}
                          >
                            <AddCircleRoundedIcon className={"fill-blue-600"} />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                    {openRows[el.id] ? (
                      <Tooltip
                        title={openRows[el.id] ? t("Close") : t("Open2")}
                        key={idx}
                      >
                        <IconButton
                          variant="outlined"
                          onClick={() => handleToggleCollapse(el.id)}
                        >
                          <KeyboardArrowUpIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={openRows[el.id] ? t("Close") : t("Open2")}
                        key={idx}
                      >
                        <IconButton
                          variant="outlined"
                          onClick={() => handleToggleCollapse(el.id)}
                        >
                          <KeyboardArrowDownIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>
                <Divider />

                {el?.practiceServices &&
                  openRows[el.id] &&
                  el?.practiceServices?.map((row, idx) => (
                    <>
                      <div
                        className="flex p-4 h-20  items-center space-x-16 bg-zinc-50"
                        key={idx}
                      >
                        <div className="flex w-24 h-24 items-center">
                          <img
                            alt="Immagine"
                            src={row.iconUrl || "/img/placeholder-image.svg"}
                            style={{
                              maxWidth: "60px",
                              maxHeight: "60px",
                            }}
                          />
                          <p
                            className="absolute flex w-14 justify-end font-bold"
                            style={{ marginLeft: "40px", marginTop: "50px" }}
                          >
                            {row.aiPromptId && <CoreIAicon />}
                          </p>
                        </div>
                        <div className="w-6/12">
                          <h4 className="m-0">{row.name}</h4>
                          <p className="m-0">{row.description}</p>
                        </div>
                        <Divider orientation="vertical" flexItem />

                        <div className="flex items-center">
                          {subRole === "Responsabile" &&
                            studio?.Data?.adminStudioServices.some(
                              (e) => e.practiceServiceId === row.id
                            ) && (
                              <>
                                <Tooltip title={t("Edit")}>
                                  <IconButton
                                    variant="outlined"
                                    onClick={() => handleOpen(row)}
                                  >
                                    <EditRoundedIcon />
                                  </IconButton>
                                </Tooltip>

                                {!row.isForAll && (
                                  <Tooltip title={t("Remove")}>
                                    <IconButton
                                      variant="outlined"
                                      onClick={() =>
                                        handleRemoveServiceGroup(row)
                                      }
                                    >
                                      <HighlightOffRoundedIcon
                                        className={"fill-orange-500"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </>
                            )}
                        </div>
                        {row.isForAll ? (
                          <CoreButton
                            disabled={subRole !== "Responsabile"}
                            testo={
                              studio?.Data?.adminStudioServices.some(
                                (e) => e.practiceServiceId === row.id
                              )
                                ? t("DeActive")
                                : t("Active")
                            }
                            className={
                              studio?.Data?.adminStudioServices.some(
                                (e) => e.practiceServiceId === row.id
                              )
                                ? "btn-round-outline"
                                : "btn-round"
                            }
                            onClick={() => handleActivationService(row)}
                          />
                        ) : (
                          <CoreButton
                            disabled={subRole !== "Responsabile"}
                            {...getServiceButtonProps(row)}
                            onClick={() => handleActivationMyService(row)}
                          />
                        )}
                      </div>
                      <Divider />
                    </>
                  ))}
                {el?.practiceServices.length === 0 && openRows[el.id] && (
                  <div className="h-16 w-full flex justify-center items-center text-gray bg-zinc-50">
                    {t("NotServices")}
                  </div>
                )}
                <Divider />
              </>
            ))
          : null}

        {services
          .filter((e) =>
            subRole === SUB_ROLE.OPERATOR
              ? studio?.Data?.adminStudioServices.some(
                  (p) => p.practiceServiceId === e.id
                )
              : e
          )
          .map((el, idx) => (
            <>
              <div className="flex py-5 items-center space-x-16" key={idx}>
                <div className="flex w-24 h-24 items-center">
                  <img
                    alt="Immagine"
                    src={el.iconUrl || "/img/placeholder-image.svg"}
                    style={{
                      maxWidth: "90px",
                      maxHeight: "90px",
                    }}
                  />
                  <p
                    className="absolute flex w-14 justify-end font-bold"
                    style={{ marginLeft: "70px", marginTop: "80px" }}
                  >
                    {el.aiPrompt && <CoreIAicon />}
                  </p>
                </div>
                <div className="w-6/12">
                  <h3 className="m-0">
                    {el.name}
                    {subRole === "Responsabile" &&
                      studio?.Data?.adminStudioServices.some(
                        (e) => e.practiceServiceId === el.id
                      ) &&
                      !el.isForAll && (
                        <Tooltip title={t("Custom")}>
                          <StarsRoundedIcon style={{ color: colorPrimary }} />
                        </Tooltip>
                      )}{" "}
                  </h3>
                  <p className="m-0">{el.description}</p>
                </div>
                <Divider orientation="vertical" flexItem />

                <div className="flex flex-col items-center">
                  {t("Category")}
                  <CoreViewLists
                    value={el.categories}
                    text={t("DocCategories")}
                  />
                </div>

                <Divider orientation="vertical" flexItem />
                <div className="flex items-center">
                  {subRole === "Responsabile" &&
                    studio?.Data?.adminStudioServices.some(
                      (e) => e.practiceServiceId === el.id
                    ) && (
                      <Tooltip title={t("Edit")}>
                        <IconButton
                          variant="outlined"
                          onClick={() => handleOpen(el)}
                        >
                          <EditRoundedIcon />
                        </IconButton>
                      </Tooltip>
                    )}

                  {subRole === "Responsabile" &&
                    appConfig?.modules?.services?.serviceTwoLevel &&
                    studio?.Data?.adminStudioServices.some(
                      (e) => e.practiceServiceId === el.id
                    ) &&
                    !el.isForAll && (
                      <Tooltip title={t("AddLevel")}>
                        <IconButton
                          variant="outlined"
                          onClick={() => handleOpenServiceTwoLevel(el)}
                        >
                          <AddBoxRoundedIcon className={`fill-yellow-500`} />
                        </IconButton>
                      </Tooltip>
                    )}
                </div>
                {el.isForAll ? (
                  <CoreButton
                    disabled={subRole !== "Responsabile"}
                    testo={
                      studio?.Data?.adminStudioServices.some(
                        (e) => e.practiceServiceId === el.id
                      )
                        ? t("DeActive")
                        : t("Active")
                    }
                    className={
                      studio?.Data?.adminStudioServices.some(
                        (e) => e.practiceServiceId === el.id
                      )
                        ? "btn-round-outline"
                        : "btn-round"
                    }
                    onClick={() => handleActivationService(el)}
                  />
                ) : (
                  <CoreButton
                    disabled={subRole !== "Responsabile"}
                    {...getServiceButtonProps(el)}
                    onClick={() => handleActivationMyService(el)}
                  />
                )}
              </div>
              <Divider />
            </>
          ))}
        <div className="w-full flex justify-center">
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={
              Math.ceil(generalServices?.Data?.count / TABLE_ROWS_NUMBER) || 1
            }
          />
        </div>
      </div>
      <CoreModal
        width={"70%"}
        height={"80%"}
        state={open}
        onClose={handleClose}
        component={
          <DetailServiceBusiness
            handleClose={handleClose}
            service={service}
            handleEditDescription={handleEditDescription}
            refetchService={refetchServices && refetchStudio}
          />
        }
      />
      <CoreModal
        width={500}
        height={400}
        state={openAddService}
        onClose={handleCloseAddService}
        component={
          <AddService
            dataService={services
              ?.filter((el) => !el.isForAll)
              ?.filter((el) => el.practiceServiceCategoryId === null)
              ?.map((el) => ({
                ...el,
                isActive: studio?.Data?.adminStudioServices.some(
                  (e) => e.practiceServiceId === el.id
                ),
              }))}
            isLoading={isLoading}
            group={service}
            onClose={handleCloseAddService}
          />
        }
      />
      <CoreModal
        width={"70%"}
        height={"80%"}
        state={openServiceTwoLevelModal}
        onClose={handleCloseServiceTwoLevel}
        component={
          <ServiceTwoLevel
            data={service}
            onClose={handleCloseServiceTwoLevel}
          />
        }
      />
      <CoreModal
        width={700}
        height={600}
        state={newOpen}
        onClose={handleProponiServiceClose}
        component={
          <div className="text-center d-flex justify-center">
            <h2>Proposta nuovo servizio studio</h2>
            <CoreTextArea
              size="small"
              className="w-full py-8"
              type="text"
              placeholder="Inserisci il titolo"
              value={newService.Name}
              onChange={(e) =>
                setNewService({ ...newService, Name: e.target.value })
              }
            />
            <CoreTextArea
              className="w-full py-8"
              name="description"
              placeholder="Inserisci la descrizione"
              rows={5}
              value={newService.Description}
              onChange={(e) =>
                setNewService({
                  ...newService,
                  Description: e.target.value,
                })
              }
            />
            <div className="mt-7">
              <CoreButton
                testo={isLoadingSuggest ? "attendere" : "Invia"}
                className="btn-round"
                onClick={handleSuggestService}
                disabled={
                  !newService.Name ||
                  !newService.Description ||
                  isLoadingSuggest
                }
              />
            </div>
          </div>
        }
      />
      <CoreDialog
        open={confirmDeleteGroupDialog}
        title={t("Delete") + " " + t("serviceTwoLevel")}
        content={`${t("DeleteConfirm")} ${service?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDeleteDialog}
        closeDialog={handleCloseDeleteDialod}
      />
      <CoreDialog
        open={showConfirmRemoveDialog}
        title={t("RemoveService")}
        content={`${t("RemoveConfirm")} ${service?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermRemoveDialog}
        closeDialog={handleCloseRemoveDialod}
      />
    </div>
  );
};

export default ServiziStudioPage;
